const IOTypes = {
    Text: 'Text',
    Binary: 'Binary',
    Image: 'Image',
    Mesh: 'Mesh'
};
export default IOTypes;
